import { render } from "./KeyboardShortcuts.vue?vue&type=template&id=5b5dce12"
import script from "./KeyboardShortcuts.vue?vue&type=script&lang=js"
export * from "./KeyboardShortcuts.vue?vue&type=script&lang=js"

import "./KeyboardShortcuts.vue?vue&type=style&index=0&id=5b5dce12&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/navbar/KeyboardShortcuts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b5dce12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b5dce12', __exports__)) {
    console.log('reload')
    api.reload('5b5dce12', __exports__)
  }
  
  module.hot.accept("./KeyboardShortcuts.vue?vue&type=template&id=5b5dce12", () => {
    console.log('re-render')
    api.rerender('5b5dce12', render)
  })

}


export default __exports__